$(function() {
  $('.tab-btn').on('click', function() {
    var tabWrap = $(this).parents('.tab-wrap');
    var tabBtn = tabWrap.find(".tab-btn");
    var tabContents = tabWrap.find('.tab-contents');
    tabBtn.removeClass('show');
    $(this).addClass('show');
    var elmIndex = tabBtn.index(this);
    tabContents.removeClass('show');
    tabContents.eq(elmIndex).addClass('show');
  });

  $('.ac-child').css("display", "none");
  $('.ac-parent').on('click', function () {
    $(this).next().slideToggle();
    $(this).find('.ac_icon').toggleClass('active');
  });

  $('.sns_on_image').hide();
  $('.reiko_sns li').hover(
    function() {
      $(this).find('.sns_off_image').hide();
      $(this).find('.sns_on_image').show();
    },
    function() {
      $(this).find('.sns_off_image').show();
      $(this).find('.sns_on_image').hide();
    }
  );
  
  $('.play_the_video').on('click',function(){	
    $('.modal-container').addClass('active');
    return false;
  });
  $('.modal-close').on('click',function(){	
    $('.modal-container').removeClass('active');
  });
  $('.modal-container').on('click',function(){	
    $('.modal-container').removeClass('active');
  });

  $(".menu_button").click(function () {
    $(this).find('.openbtn').toggleClass('active');
    if( $(this).find('.openbtn').hasClass('active') ) {
      $('.menu_button_text').text('CLOSE');
      $('.slide_menu').addClass('open');
    } else {
      $('.menu_button_text').text('MENU');
      $('.slide_menu').removeClass('open');
    }
  });

  $('.slide_menu a').click(function(){
    $(".openbtn").removeClass('active');
    $('.menu_button_text').text('MENU');
    $('.slide_menu').removeClass('open');
    var adjust = 0;
    var speed = 600;
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top - adjust;
    $('body,html').animate({scrollTop:position}, speed, 'swing');
    return false;
  });

  $(window).scroll(function(){
    var obj = $('.reiko_logo');
    var video = $('.play_the_video');
    var scrolldown = $('.scrolldown');
    var menu = $('.menu_button');
    scroll = $(window).scrollTop();
    if (scroll > 1) {
      obj.addClass('isSmall');
      video.fadeOut(500);
      scrolldown.fadeOut(500);
      menu.addClass('istop');
    } else{
      obj.removeClass('isSmall');
      video.fadeIn(500);
      scrolldown.fadeIn(500);
      menu.removeClass('istop');
    }
  });
  
 });

$(window).on('load', function() {
  var path_name = location.pathname;
  
  if(path_name.indexOf("en") > -1) {
    $('.english').addClass('on_language');
    $('.japanese').removeClass('on_language');
  } else {
    $('.japanese').addClass('on_language');
    $('.english').removeClass('on_language');
  }
});

$('.tab-btn').on('click', function () {
  var tab_value = $(this).text();
  localStorage.setItem('tab_name', tab_value);
});

var $arr_new_all = $('.sort_news_all').sort(function(a, b){
  return ($(a).find('.ac_date').text() < $(b).find('.ac_date').text() ? 1 : -1);
});
$arr_new_all.each(function (i, v) {
  $('.sort_news_all').parent('dl.ac').append(v);
});

var $arr_news = $('.sort_NEWS').sort(function(a, b){
  return ($(a).find('.ac_date').text() < $(b).find('.ac_date').text() ? 1 : -1);
});
$arr_news.each(function (i, v) {
  $('.sort_NEWS').parent('dl.ac').append(v);
});

var $arr_media = $('.sort_MEDIA').sort(function(a, b){
  return ($(a).find('.ac_date').text() < $(b).find('.ac_date').text() ? 1 : -1);
});
$arr_media.each(function (i, v) {
  $('.sort_MEDIA').parent('dl.ac').append(v);
});

var $arr_live = $('.sort_LIVE').sort(function(a, b){
  return ($(a).find('.ac_date').text() < $(b).find('.ac_date').text() ? 1 : -1);
});
$arr_live.each(function (i, v) {
  $('.sort_LIVE').parent('dl.ac').append(v);
});

var $arr_media_all = $('.sort_media_all').sort(function(a, b){
  return ($(a).find('.ac_date').text() < $(b).find('.ac_date').text() ? 1 : -1);
});
$arr_media_all.each(function (i, v) {
  $('.sort_media_all').parent('dl.ac').append(v);
});

var $arr_web = $('.sort_WEB').sort(function(a, b){
  return ($(a).find('.ac_date').text() < $(b).find('.ac_date').text() ? 1 : -1);
});
$arr_web.each(function (i, v) {
  $('.sort_WEB').parent('dl.ac').append(v);
});

var $arr_magazine = $('.sort_MAGAZINE').sort(function(a, b){
  return ($(a).find('.ac_date').text() < $(b).find('.ac_date').text() ? 1 : -1);
});
$arr_magazine.each(function (i, v) {
  $('.sort_MAGAZINE').parent('dl.ac').append(v);
});

var $arr_radio = $('.sort_RADIO').sort(function(a, b){
  return ($(a).find('.ac_date').text() < $(b).find('.ac_date').text() ? 1 : -1);
});
$arr_radio.each(function (i, v) {
  $('.sort_RADIO').parent('dl.ac').append(v);
});

var $arr_tv = $('.sort_TV').sort(function(a, b){
  return ($(a).find('.ac_date').text() < $(b).find('.ac_date').text() ? 1 : -1);
});
$arr_tv.each(function (i, v) {
  $('.sort_TV').parent('dl.ac').append(v);
});

var $arr_2023 = $('.sort_2023').sort(function(a, b){
  return ($(a).find('.ac_date').text() < $(b).find('.ac_date').text() ? 1 : -1);
});
$arr_2023.each(function (i, v) {
  $('.sort_2023').parent('dl.ac').append(v);
});

var $arr_2024 = $('.sort_2024').sort(function(a, b){
  return ($(a).find('.ac_date').text() < $(b).find('.ac_date').text() ? 1 : -1);
});
$arr_2024.each(function (i, v) {
  $('.sort_2024').parent('dl.ac').append(v);
});

var $arr_2025 = $('.sort_2025').sort(function(a, b){
  return ($(a).find('.ac_date').text() < $(b).find('.ac_date').text() ? 1 : -1);
});
$arr_2025.each(function (i, v) {
  $('.sort_2025').parent('dl.ac').append(v);
});

var $arr_music_all = $('.sort_music_all').sort(function(a, b){
  return ($(a).find('.ac_date').text() < $(b).find('.ac_date').text() ? 1 : -1);
});
$arr_music_all.each(function (i, v) {
  $('.sort_music_all').parent('div.music_image_flex').append(v);
});

var $arr_music_single = $('.sort_music_SINGLE').sort(function(a, b){
  return ($(a).find('.ac_date').text() < $(b).find('.ac_date').text() ? 1 : -1);
});
$arr_music_single.each(function (i, v) {
  $('.sort_music_SINGLE').parent('div.music_image_flex').append(v);
});

var $arr_music_album = $('.sort_music_ALBUM').sort(function(a, b){
  return ($(a).find('.ac_date').text() < $(b).find('.ac_date').text() ? 1 : -1);
});
$arr_music_album.each(function (i, v) {
  $('.sort_music_ALBUM').parent('div.music_image_flex').append(v);
});

var $arr_music_other = $('.sort_music_OTHERS').sort(function(a, b){
  return ($(a).find('.ac_date').text() < $(b).find('.ac_date').text() ? 1 : -1);
});
$arr_music_other.each(function (i, v) {
  $('.sort_music_OTHERS').parent('div.music_image_flex').append(v);
});
